export const formContentSx = {
  maxWidth: '350px',
};

export const formTitleSx = (theme) => ({
  color: theme.palette.secondary.main,
  fontWeight: 800,
  fontSize: 24,
});
